export default "__VITE_ASSET__52e98fef__"